import { ChartTableOfContentsType } from '@/types';

export const chartData: ChartTableOfContentsType[] = [
  {
    heading: 'demand',
    items: [
      {
        description: 'Agricultural & Municipal & Industrial Demands',
        id: 20,
        areas: [1, 2, 4, 6, 7, 8, 10, 11, 12, 13, 14],
        sectors: [0],
      },
      {
        description: 'Total System-wide Demand',
        id: 1,
        areas: [1, 2, 4, 5, 6, 7, 8, 10, 11, 12, 13, 14],
        sectors: [1],
      },
      {
        description: 'Demand per Water Demand Category',
        id: 2,
        areas: [1, 2, 4, 5, 6, 7, 8, 10, 11, 12, 13, 14],
        sectors: [1],
      },
      {
        description: 'Industrial Demand by SSI Type',
        id: 3,
        areas: [1, 2, 4, 5, 8, 10, 11, 12, 13, 14, 15],
        sectors: [1],
      },
      {
        description: 'Demand vs. Demand Met',
        id: 5,
        areas: [1, 2, 4, 6, 7, 8, 10, 11, 13, 14],
        sectors: [1],
      },
      {
        description: 'Demand vs. Demand Met',
        id: 13,
        areas: [1, 2, 4, 6, 7, 8, 10, 11, 13, 14],
        sectors: [2],
      },

      {
        description: 'Total Agricultural Diversion Demand',
        id: 11,
        areas: [1, 2, 4, 6, 7, 8, 10, 11, 12, 13, 14],
        sectors: [2],
      },
      {
        description: 'Agricultural Diversion Demand by Basin',
        id: 25,
        areas: [12],
        sectors: [2],
      },
      {
        description: 'Average IWR Change Factors',
        id: 26,
        areas: [12],
        sectors: [2],
      },
      {
        description: 'Annual Agricultural Demand',
        areas: [1, 2, 4, 6, 8, 10, 11, 13, 14],
        sectors: [2],
        id: 117, // custom id not related to a plot id
        subPlots: {
          timeline: {
            description: 'Annual Agricultural Demands',
            id: 17,
          },
          summary: {
            description: 'Summary of Annual Agricultural Demands',
            id: 18,
          },
        },
      },
    ],
  },
  {
    heading: 'risk',
    items: [
      {
        description: 'Agricultural & Municipal & Industrial Gaps',
        id: 19,
        areas: [1, 2, 4, 6, 7, 8, 10, 11, 12, 13, 14],
        sectors: [0],
      },

      {
        description: 'M&I Total Gap',
        id: 6,
        areas: [1, 2, 4, 6, 7, 8, 10, 11, 12, 13, 14],
        sectors: [1],
      },
      {
        description: 'Annual M&I Gap',
        areas: [2, 4, 6, 8, 10, 11, 13, 14],
        sectors: [1],
        id: 107,
        subPlots: {
          timeline: {
            description: 'Annual M&I Gaps (% of Demand)',
            id: 7,
          },
          summary: {
            description: 'Summary of Annual M&I Gaps',
            id: 8,
          },
        },
      },
      {
        description: 'Agricultural Gap',
        areas: [1, 2, 4, 6, 7, 8, 10, 11, 12, 13, 14],
        sectors: [2],
        id: 14,
      },
      {
        description: 'Annual Agricultural Gap',
        areas: [1, 2, 4, 6, 7, 8, 10, 11, 12, 13, 14, 15],
        sectors: [2],
        id: 115,
        subPlots: {
          timeline: {
            description: 'Annual Agricultural Gap (% of Demand)',
            id: 15,
          },
          summary: {
            description: 'Summary of Annual Agricultural Gap',
            id: 16,
          },
        },
      },
    ],
  },
  {
    heading: 'waterSupply',
    items: [
      {
        description: 'Reservoir Storage Timeline',
        areas: [2, 4, 6, 10, 11, 13, 14],
        sectors: [0],
        id: 21,
      },
      {
        description: 'Reservoir Storage Summary by Month',
        areas: [2, 4, 6, 10, 11, 13, 14],
        sectors: [0],
        id: 22,
      },
      {
        description: 'Available Water Flow Timeline',
        areas: [2, 4, 6, 10, 11, 13, 14],
        sectors: [0],
        id: 23,
      },
    ],
  },
  {
    heading: 'other',
    items: [
      {
        description: 'Total Irrigated Acreage',
        areas: [1, 2, 4, 6, 7, 8, 10, 11, 12, 13, 14, 15],
        sectors: [2],
        id: 12,
      },
      {
        description: 'Total Count of Occurrences of E&R Macro-Attributes',
        areas: [1, 2, 4, 6, 7, 8, 10, 11, 13, 14, 15],
        sectors: [3],
        id: 27,
      },
      {
        description: 'Projected Population',
        sectors: [0, 1, 2],
        areas: [1, 2, 4, 5, 6, 7, 8, 10, 11, 12, 13, 14],
        id: 4,
      },
    ],
  },
];
